module.exports = __webpack_public_path__ + "img/lsd.5dd0cdf4.png";